import { Box, Typography, Link } from "@mui/material";
const Footer = () => {
  const companyLogo = `${process.env.REACT_APP_BASE_API}/${process.env.REACT_APP_COMPANY_LOGO}`;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#f5f5f5",
        borderTop: "1px solid #e0e0e0",
        py: 2,
        px: 4,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        gap={2}
      >
        {companyLogo && (
          <img
            src={companyLogo}
            alt="Company Logo"
            style={{ height: 40, objectFit: "contain" }}
          />
        )}
        <Typography variant="body2" color="text.secondary">
          &copy; {new Date().getFullYear()} ZenBook. All rights reserved.
        </Typography>
        <Link underline="hover" color="primary">
          Terms and Conditions
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
